import {
  knowledgeProductsResponseSchema,
  paths,
  type KnowledgeProductsResponse,
} from "@go-novus/admin-api";

import {
  requestBackendResult,
  type BackendFailure,
} from "#/shared/lib/backend-api";
import type { ResultAsync } from "#/shared/lib/result";

/** Products 标签的读操作，与其余四类分开：它多了搜索和类目筛选。 */
export const getKnowledgeProductsOperation = "knowledge.products";

export type GetKnowledgeProductsOperation =
  typeof getKnowledgeProductsOperation;

export type GetKnowledgeProductsFailure =
  BackendFailure<GetKnowledgeProductsOperation>;

/** 搜索与类目均缺省时不筛，与契约的 optional 一致。 */
export interface KnowledgeProductFilters {
  category: string | undefined;
  q: string | undefined;
}

function readQueryString(
  filters: KnowledgeProductFilters,
  cursor: string | null,
): string {
  const params = new URLSearchParams();

  if (filters.q !== undefined) {
    params.set("q", filters.q);
  }

  if (filters.category !== undefined) {
    params.set("category", filters.category);
  }

  if (cursor !== null) {
    params.set("cursor", cursor);
  }

  const query = params.toString();

  return query === "" ? "" : `?${query}`;
}

/** 游标是后端给的不透明串，前端只原样回传；null 表示取第一页。 */
export function getKnowledgeProducts(
  filters: KnowledgeProductFilters,
  cursor: string | null,
  options: { fetch?: typeof globalThis.fetch; signal?: AbortSignal } = {},
): ResultAsync<KnowledgeProductsResponse, GetKnowledgeProductsFailure> {
  return requestBackendResult({
    fetch: options.fetch,
    method: "GET",
    operation: getKnowledgeProductsOperation,
    parse: (payload) => knowledgeProductsResponseSchema.parse(payload),
    path: `${paths.knowledgeProducts}${readQueryString(filters, cursor)}`,
    signal: options.signal,
  });
}
